import { render, staticRenderFns } from "./num.vue?vue&type=template&id=5ce5c8e0&"
var script = {}
import style0 from "./num.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports